var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            stripe: "",
            "highlight-current-row": "",
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "empNo",
              label: _vm.$t("salesKPIManagement.table.empNo"),
              width: "120",
              fixed: "",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "empName",
              label: _vm.$t("salesKPIManagement.table.empName"),
              width: "100",
              fixed: "",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "brand",
              label: _vm.$t("salesKPIManagement.table.brand"),
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "year",
              label: _vm.$t("salesKPIManagement.table.year"),
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "oneSigningTargetQty",
              label: _vm.$t("contractKPIManagement.table.oneSigningTargetQty"),
              width: "125",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "twoSigningTargetQty",
              label: _vm.$t("contractKPIManagement.table.twoSigningTargetQty"),
              width: "125",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "threeSigningTargetQty",
              label: _vm.$t(
                "contractKPIManagement.table.threeSigningTargetQty"
              ),
              width: "125",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "fourSigningTargetQty",
              label: _vm.$t("contractKPIManagement.table.fourSigningTargetQty"),
              width: "125",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "fiveSigningTargetQty",
              label: _vm.$t("contractKPIManagement.table.fiveSigningTargetQty"),
              width: "125",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sixSigningTargetQty",
              label: _vm.$t("contractKPIManagement.table.sixSigningTargetQty"),
              width: "125",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sevenSigningTargetQty",
              label: _vm.$t(
                "contractKPIManagement.table.sevenSigningTargetQty"
              ),
              width: "125",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "eightSigningTargetQty",
              label: _vm.$t(
                "contractKPIManagement.table.eightSigningTargetQty"
              ),
              width: "125",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "nineSigningTargetQty",
              label: _vm.$t("contractKPIManagement.table.nineSigningTargetQty"),
              width: "125",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "tenSigningTargetQty",
              label: _vm.$t("contractKPIManagement.table.tenSigningTargetQty"),
              width: "125",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "elevenSigningTargetQty",
              label: _vm.$t(
                "contractKPIManagement.table.elevenSigningTargetQty"
              ),
              width: "125",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "twelveSigningTargetQty",
              label: _vm.$t(
                "contractKPIManagement.table.twelveSigningTargetQty"
              ),
              width: "125",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "oneActiveTargetQty",
              label: _vm.$t("contractKPIManagement.table.oneActiveTargetQty"),
              width: "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "twoActiveTargetQty",
              label: _vm.$t("contractKPIManagement.table.twoActiveTargetQty"),
              width: "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "threeActiveTargetQty",
              label: _vm.$t("contractKPIManagement.table.threeActiveTargetQty"),
              width: "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "fourActiveTargetQty",
              label: _vm.$t("contractKPIManagement.table.fourActiveTargetQty"),
              width: "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "fiveActiveTargetQty",
              label: _vm.$t("contractKPIManagement.table.fiveActiveTargetQty"),
              width: "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sixActiveTargetQty",
              label: _vm.$t("contractKPIManagement.table.sixActiveTargetQty"),
              width: "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sevenActiveTargetQty",
              label: _vm.$t("contractKPIManagement.table.sevenActiveTargetQty"),
              width: "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "eightActiveTargetQty",
              label: _vm.$t("contractKPIManagement.table.eightActiveTargetQty"),
              width: "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "nineActiveTargetQty",
              label: _vm.$t("contractKPIManagement.table.nineActiveTargetQty"),
              width: "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "tenActiveTargetQty",
              label: _vm.$t("contractKPIManagement.table.tenActiveTargetQty"),
              width: "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "elevenActiveTargetQty",
              label: _vm.$t(
                "contractKPIManagement.table.elevenActiveTargetQty"
              ),
              width: "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "twelveActiveTargetQty",
              label: _vm.$t(
                "contractKPIManagement.table.twelveActiveTargetQty"
              ),
              width: "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "errorMsg",
              label: _vm.$t("common.errorInfo"),
              "min-width": "180",
              fixed: "right",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total>0",
          },
        ],
        attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
        on: {
          "update:page": function ($event) {
            _vm.currPage = $event
          },
          "update:limit": function ($event) {
            _vm.limit = $event
          },
          pagination: _vm.fetchData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }